import { FC, memo } from 'react'

import { Select } from '../Select'
import { DEFAULT_PAGE_SIZE_OPTIONS } from './consts'

import { s } from './styles'

type Props = {
  size: number
  changeSize: (size: number) => void
}

export const Options: FC<Props> = memo((props) => {
  const { size, changeSize } = props

  if (!DEFAULT_PAGE_SIZE_OPTIONS.includes(size.toString())) {
    throw new Error('Unexpected pagination size')
  }

  const onChangeSize = (value: string) => changeSize(Number(value))

  return (
    <s.Content>
      <Select
        value={size}
        onChange={onChangeSize}
        data={DEFAULT_PAGE_SIZE_OPTIONS.map((value) => ({ label: `${value} / page`, value }))}
      />
    </s.Content>
  )
})
